import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";

import { MINIMUM_LINE_ITEM_TYPES } from "../../../sharedCode/metadata";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function MinimumsMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const applicableLineItems = ticket?.LineItems?.filter((r) => MINIMUM_LINE_ITEM_TYPES.findIndex((id) => r && id === r.line_item_type_id) >= 0);

    const details = <Typography textAlign={"center"}>{applicableLineItems?.length ?? 0} FOUND</Typography>;
    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
